<div class="container search-result">
  <!-- <pre> ID: {{document['_source']['ID']}}</pre> -->

  <div class="row item">
    <div class="col-md-2 d-flex justify-content-start">
      <span *ngIf="document['_index'] == 'fud_demko_doctyp2'">
        <span class="icon-box material-icons position-icon m-3"> person </span>
      </span>

      <span *ngIf="document['_index'] == 'fud_demko_doctyp3'">
        <span class="icon-box material-icons position-icon m-3">
          location_city
        </span>
      </span>

      <span *ngIf="document['_index'] == 'fud_demko_doctyp4'">
        <span class="icon-box material-icons position-icon m-3"> image </span>
      </span>

      <span *ngIf="document['_index'] == 'fud_demko_doctyp5'">
        <span class="icon-box material-icons position-icon m-3"> bar_chart </span>
      </span>
    </div>

    <div class="col-md-8 pt-3">
      <ng-container *ngIf="document['_type'] == '_doc'">
        <ng-container
          *ngIf="
            this.document &&
            this.document['_source'] &&
            this.document['_source']['ID']
          "
        >
          <a
            class="linkToDocument"
            href="{{environment.wordpressPageUrl}}/#/document/{{ this.document['_source']['ID'] }}"
            (click)="onInfoClick()"
          >
            <!-- Person -->

            <ng-container *ngIf="document['_index'] == 'fud_demko_doctyp2'">
           
                <ng-container *ngIf="document['_source']['2_perindex']">

                  <div class="row">
                    <div class="col">
                      <span>
                        {{document["_source"]["2_perindex"]["content"] }}
                      </span>
                    </div>
                    <div class="col">
                      <span
                      *ngFor="
                        let stadt of document['_source']['2_personstadt'];
                        let isLast = last
                      "
                    >
                      {{ stadt.content }}{{ isLast ? "" : "; " }}
                    </span>
                    </div>
                    <div class="col">
                      <span *ngFor="let partei of document['_source']['2_parteizugehoerigkeit']; let isLast = last">
                      {{ partei.content }}{{ isLast ? "" : "; " }}
                    </span>
                    </div>
                    <div class="col"></div>
                  </div>

             
                
                 
                 

                </ng-container>
     
            </ng-container>

            <!-- Stadt -->
            <ng-container *ngIf="document['_index'] == 'fud_demko_doctyp3'">
              <!-- <pre>{{document["_source"]|json}}</pre> -->

              <ng-container
                *ngIf="
                  document['_source']['3_stadt'] &&
                  document['_source']['3_stadt'].content
                "
              >
                <div>
                  {{ document["_source"]["3_stadt"].content }}
                </div>
              </ng-container>
            </ng-container>

            <!-- Protokol -->
            <ng-container *ngIf="document['_index'] == 'fud_demko_doctyp4'">
              <!-- <pre>{{document["_source"]|json}}</pre> -->

              <div class="row">
                <div class="col">
                  <ng-container
                  *ngIf="
                    document['_source']['4_tf_ort'] &&
                    document['_source']['4_tf_ort'].content
                  "
                >
                  <div>
                    {{ document["_source"]["4_tf_ort"].content }}
                  </div>
                </ng-container>
                </div>

                <div class="col">
                  <ng-container
                *ngIf="
                  document['_source']['4_motivkategorie'] &&
                  document['_source']['4_motivkategorie'].content
                "
              >
                <div>
                  {{ document["_source"]["4_motivkategorie"].content }}
                </div>
              </ng-container>
                </div>

                <div class="col">
                  <ul *ngIf="document['_source']['4_Bilddaten']">
                    <li *ngFor="let daten of document['_source']['4_Bilddaten']">
                      {{ daten["bildpersonen"][0].content }}
                    </li>
                </ul>
                </div>

                <div class="col">
                  
                </div>
              </div>
             
              
             
            </ng-container>

            <!-- Wahl -->
            <ng-container *ngIf="document['_index'] == 'fud_demko_doctyp5'">
              <!-- <pre>{{document["_source"]|json}}</pre> -->

              <div class="row">
                <div class="col">
                  <ng-container
                *ngIf="
                  document['_source']['5_erg4stadt'] &&
                  document['_source']['5_erg4stadt'].content
                "
              >
                <div>
                  {{ document["_source"]["5_erg4stadt"].content }}
                </div>
              </ng-container>
                </div>
                <div class="col">
                  <ng-container
                  *ngIf="
                    document['_source']['5_erg4wahl'] &&
                    document['_source']['5_erg4wahl'].content
                  "
                >
                  <div>
                    {{ document["_source"]["5_erg4wahl"].content }}
                  </div>
                </ng-container>
                </div>
               
                <div class="col">
                  
                </div>
                <div class="col">
                  
                </div>
              </div>
            
              
              
            
            
            </ng-container>
            
          </a>
        </ng-container>
      </ng-container>

      <br />
    </div>

    <div class="col-md-2 d-flex justify-content-end">
      <mat-checkbox
        class="mr-2 mt-1"
        [checked]="checked"
        (change)="onMerklistToggle($event, document)"
      >
      </mat-checkbox>
    </div>
  </div>
</div>
